import { Injectable, signal, computed } from "@angular/core";
import { TranslateObject } from "@app/views-interfaces";
import * as deliveryMethods_json from "src/assets/DeliveryMethods/DeliveryMethods.json";

@Injectable({ providedIn: "root" })
export class DeliveryMethodsService {
    public static readonly NONE_DELIVERY_METHOD_ID = "10";
    public static readonly CD_ROM_DELIVERY_METHOD_ID = "7";
    public deliveryMethods: Record<string, TranslateObject>;
    public deliveryMethodsForFilters: Record<string, TranslateObject>;

    private sDeliveryMethods = signal<Record<string, TranslateObject>>({});
    public currentDeliveryMethods = this.sDeliveryMethods.asReadonly();
    public currentDeliveryMethodById = computed(() => {
        const deliveryMethods = this.currentDeliveryMethods();
        const map = new Map<string, TranslateObject>();
        for (const key in deliveryMethods) {
            if (deliveryMethods.hasOwnProperty(key)) {
                map.set(key, deliveryMethods[key]);
            }
        }
        return map;
    });

    constructor() {
        // Remove CD-ROM and "None" option for card display
        this.deliveryMethods = Object.fromEntries(
            Object.entries(deliveryMethods_json)
                .filter(
                    (o) =>
                        o[0] !== "default" &&
                        o[0] !== DeliveryMethodsService.CD_ROM_DELIVERY_METHOD_ID &&
                        o[0] !== DeliveryMethodsService.NONE_DELIVERY_METHOD_ID,
                )
                .map((o) => [o[0], o[1] as TranslateObject]),
        );

        this.sDeliveryMethods.set(this.deliveryMethods);

        // For filters 2023 and up - include "None" option but exclude CD-ROM
        this.deliveryMethodsForFilters = Object.fromEntries(
            Object.entries(deliveryMethods_json)
                .filter((o) => o[0] !== "default" && o[0] !== DeliveryMethodsService.CD_ROM_DELIVERY_METHOD_ID)
                .map((o) => [o[0], o[1] as TranslateObject]),
        );
    }

    getDeliveryMethodsList() {
        return this.deliveryMethods;
    }

    getDeliveryMethodsListForFilters() {
        return this.deliveryMethodsForFilters;
    }
}
